import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import useNotify from "hooks/useNotify";
import { actions } from "store/actions";
import { actions as projectActions } from "store/actions";
import { scrollIntoView } from "utils/helper";

function UseCashExpressInformation() {
  const dispatch = useDispatch();
  const userDetails = useSelector((state) => state.userDetails || {});
  const [isLoading, setIsLoading] = useState(false);
  const { notifyError, notifySuccess } = useNotify();

  const onEditCashExpress = async (values) => {
    try {
      setIsLoading(true);
      const payload = {
        cashExpress: {
          fullName: values?.fullName || undefined,
          cashExpressPhoneNumber: values?.cashExpressPhoneNumber || undefined,
        },
      };
      dispatch(
        projectActions.updateCashExpressCommon(payload, (ok, err) => {
          setIsLoading(false);
          if (ok) {
            const updatedUser = {
              ...userDetails,
              bankDetails: {
                ...userDetails?.bankDetails,
                fullName: values?.fullName || undefined,
                cashExpressPhoneNumber:
                  values?.cashExpressPhoneNumber || undefined,
              },
            };
            dispatch(actions.setUserDetails(updatedUser));
            notifySuccess("Has been updated successfully");
            scrollIntoView("cashExpressSection");
          } else {
            notifyError(
              err?.data?.error ?? err?.message ?? "Something went wrong!"
            );
          }
        })
      );
    } catch (err) {
      console.error(err);
      notifyError(err?.data?.error ?? err?.message ?? "Something went wrong!");
    }
  };

  useEffect(() => () => {}, []);

  return { onEditCashExpress, isCashExpressLoading: isLoading };
}

export default UseCashExpressInformation;
